import styled from 'styled-components';

import {
  spacing,
  companyColor,
  defaultColor,
  font,
} from 'styles/theme';

export const TipContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing('small')};
  margin: ${spacing('extraSmall')} 0;
`;

export const PresetButtons = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: ${spacing('extraSmall')};

  @media (max-width: 600px) {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    align-items: stretch;
  }
`;

export const TipButton = styled.button`
  min-width: 72px;
  min-height: 32px;
  padding: 0 ${spacing('small')};
  font-size: 11px;
  font-family: ${font('medium')};
  border: 1px solid ${companyColor('main')};
  border-radius: 6px;
  background: ${(props) => (props.$active ? companyColor('main') : 'transparent')};
  color: ${(props) => (props.$active ? '#ffffff' : companyColor('main'))};
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  white-space: nowrap;

  &:hover {
    background: ${(props) => (props.$active ? companyColor('main') : 'rgba(46, 55, 88, 0.08)')};
  }

  @media (max-width: 420px) {
    min-width: 0;
    min-height: 34px;
    height: auto;
    padding: 6px ${spacing('extraSmall')};
    white-space: normal;
    flex-direction: column;
    line-height: 1.15;
  }
`;

export const AmountHint = styled.span`
  opacity: 0.85;
`;

export const CustomRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing('small')};

  @media (max-width: 420px) {
    flex-wrap: wrap;
    gap: ${spacing('extraSmall')};
  }
`;

export const TipInput = styled.input`
  width: min(180px, 100%);
  max-width: 100%;
  height: 36px;
  padding: 0 12px;
  border: 1px solid ${companyColor('background')};
  border-radius: 6px;
  font-family: ${font('regular')};
  font-size: 13px;
  color: ${companyColor('font')};
  background: none;
  outline: none;
  transition: border-color 240ms linear;

  &:focus {
    border-color: ${companyColor('font')};
  }

  &::placeholder {
    color: ${companyColor('grey')};
  }

  @media (max-width: 420px) {
    width: 100%;
  }
`;

export const SummaryAmount = styled.span`
  font-family: ${font('medium')};
  color: ${companyColor('font')};
`;

export const ValidationError = styled.div`
  color: ${defaultColor('red')};
  font-family: ${font('regular')};
  font-size: 12px;
`;
